__turbopack_context__.v({
  "className": "fkromanstandard_a240082-module__ue_kfq__className",
  "variable": "fkromanstandard_a240082-module__ue_kfq__variable",
});
